import { findModuleExport } from '../webpack';
/** @component React Components */
export const SteamSpinner = findModuleExport((e) => e?.toString?.()?.includes('Steam Spinner') && e?.toString?.()?.includes('src'));
